import React, { Component } from 'react';

import config from 'config';
import Slider from 'react-slick';

const isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
	},
	any: function () {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};

const downloadUrl = isMobile.iOS() ? config.appStore : config.playStore;

export default class OnMobile extends Component {
	render() {
		var settings = {
			dots: true,
			infinite: false,
			arrows: false,
			swipe: true,
			speed: 500,
			slidesToShow: 1.5,
			slidesToScroll: 1.5
		};

		return (
			<div id="on-mobile">
				<div className="download-container">
					<div className="container-center">
						<div className="container-title">
							<h2>Speed Content</h2>

							<p>
								Baixe o aplicativo e tenha acesso a novidades, campanhas e produtos do nosso portfólio.
								
	            </p>
						</div>

						<div className="download-button-container">
							<img alt="" src={require('../img/icon-download.svg')} />
							<a href={downloadUrl} target="_blank">
								<button>Baixar</button>
							</a>
						</div>
					</div>
				</div>

				<div className="player-container">
					<div className="container-center">
						<Slider {...settings}>
							<div><img alt="" src={require("../img/telas/01.jpg")} /></div>
							<div><img alt="" src={require("../img/telas/02.jpg")} /></div>
						</Slider>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/OnMobile.js